export default (value, length) => {
  return (value != null && value.length > length) ? value.substring(0, length) + '...' : value
}
